// Mirrors backend `CO_TRANSITIONS` in /app/backend/routes/orders.py
// Customer order item transitions. Use getAllowedNextStatuses(item) to drive the dropdown.
export const CO_TRANSITIONS = {
  'Ordered from Vendor': ['Dispatched from Vendor', 'Received in Store', 'Cancelled'],
  'Dispatched from Vendor': ['Received in Store', 'Pending'],
  'Received in Store': ['Delivered', 'Cancelled'],
  'Delivered': [],
  'Cancelled': [],
  'Pending': ['Ready for Delivery', 'Dispatched from Vendor', 'Ordered from Vendor'],
  'Ready for Delivery': ['Delivered', 'Cancelled', 'Dispatched from Vendor'],
};

// Statuses that are not cancellable, EXCEPT for items with from_stock=true in 'Ready for Delivery'
const NON_CANCELLABLE = ['Delivered', 'Dispatched from Vendor', 'Pending', 'Ready for Delivery'];

/**
 * Compute the dropdown options for an order item.
 * - Always includes the current status (so the Select shows the current value cleanly).
 * - Filters disallowed transitions per backend rules.
 * - Respects the from_stock cancel exemption.
 */
export const getAllowedNextStatuses = (item) => {
  const current = item?.status || 'Ordered from Vendor';
  const fromStock = !!item?.from_stock;
  const allowed = CO_TRANSITIONS[current] || [];

  const filtered = allowed.filter((s) => {
    if (s !== 'Cancelled') return true;
    // Cancel rule: blocked from non-cancellable statuses, but allowed for from_stock + Ready for Delivery
    if (fromStock && current === 'Ready for Delivery') return true;
    return !NON_CANCELLABLE.includes(current);
  });

  // Always surface the current status in the dropdown (so it renders, even if terminal)
  return Array.from(new Set([current, ...filtered]));
};

export const ALL_STATUSES = [
  'Ordered from Vendor',
  'Dispatched from Vendor',
  'Received in Store',
  'Ready for Delivery',
  'Delivered',
  'Cancelled',
  'Pending',
];
